import { connect } from 'react-redux';
import { adjustColorBrightness } from 'sharedParts';

import stylingSelector from '../selectors';

const { getStylingPageBackgroundColor } = stylingSelector;

const mapStateToProps = (state, { style }) => {
  const backgroundColor = getStylingPageBackgroundColor(state);
  return {
    style: {
      borderColor: adjustColorBrightness(backgroundColor, -0.1),
      backgroundColor,
      ...style,
    },
  };
};

export default connect(mapStateToProps);
